import React from 'react';
import Proptypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Container, Divider, Typography } from '@material-ui/core';
import { Creators as RoomActions } from '~/store/modules/rooms/ducks';
import StandardModal from '~/components/Modal';

export default function DeleteRoomModal({ closeCallback }) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.room.loading);
  const { params: roomInfo } = useSelector((state) => state.modal);

  const handleClose = () => {
    closeCallback();
  };

  const handleDeleteRoom = async () => {
    dispatch(
      RoomActions.roomDeleteRequest({ close: handleClose, id: roomInfo.id })
    );
  };

  return (
    <StandardModal
      title="Excluir Sala"
      onClose={handleClose}
      isOpened
      maxWidth="sm"
      showDividers
      actionElements={
        <Box display="flex" p={2}>
          <Box px={2}>
            <Button onClick={handleClose}>Cancelar</Button>
          </Box>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            onClick={handleDeleteRoom}
            disabled={loading}
          >
            Excluir Agora
          </Button>
        </Box>
      }
      slideTo="left"
      fullWidth
    >
      <Box
        className="h-100"
        display="flex"
        alignItems="center"
        justifyContent="center"
        pt={5}
      >
        <Container maxWidth="xs">
          <Box mb={4}>
            <Typography variant="h5">
              Deseja realmente excluir a sala seguir?
            </Typography>
            <br />
            <Typography variant="h6" color="primary">
              {roomInfo.name}
            </Typography>
            <Divider />
            <br />
            <Typography variant="subtitle1">
              Obs: O sistema irá redistribuir os participantes dessa sala em
              outras disponíveis(se houver)
            </Typography>
          </Box>
          <Box
            mb={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
          />
        </Container>
      </Box>
    </StandardModal>
  );
}

DeleteRoomModal.propTypes = {
  closeCallback: Proptypes.func.isRequired,
};
